import { useEffect, useRef } from 'react';
import { Link } from '@framework/router/Next/Link';
import { getCatalogRoute } from '@/creditflowresearch/Router/RouteWithRedirect/getNewRoute';
import ICompany from '@/creditflowresearch/domain/vo/ICompany';
import { useVirtualListContext } from '@creditflowresearch/uilib/VirtualListContext';

import styles from './catalogItem.module.scss';

export interface ICatalogItemData {
  [label: string]: ICompany[],
}

interface IProps {
  items: ICatalogItemData[],
  index: number,
  catalogUrl: string,
}

const CatalogItem = ({ items, index, catalogUrl }: IProps) => {
  const [label, values] = Object.entries(items[index])[0];
  const { setSize } = useVirtualListContext();
  const itemRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const { height = 20 } = itemRef.current?.getBoundingClientRect() ?? {};
    setSize(index, height);
  }, [setSize, index]);

  return (
    <div className={ styles.catalogItem } ref={ itemRef }>
      <div className={ styles.catalogItemLabel }>{ label }</div>
      <div className={ styles.catalogItemContent }>
        { values.map((item: ICompany) => (
          <p key={ item.viewId }>
            <Link
              to={ getCatalogRoute(catalogUrl, item) }
              title={ item.title }
              target="_blank"
            >
              { item.name }
            </Link>
          </p>
        )) }
      </div>
    </div>
  );
};

export default CatalogItem;
